export const DAILY_HOROSCOPE_PROMPT_FILE_NAME_PARAM = 'seo_page_prompt';
export const DAILY_HOROSCOPE_MONITORING_ERROR_REASON_TAG = 'daily-horoscope-not-found';
